import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filesize'
})
export class FileSizePipe implements PipeTransform {
  transform(size: number, aftPoint: number = 2, is_smart: boolean = false, pointed: boolean = false): any {
    let val;

    if (size >= 1099511627776) { // 1 TB
      val = (is_smart ? Math.round(size / 1099511627776) : (size / 1099511627776).toFixed(aftPoint)) + (is_smart ? 'TB' : ' TB');
    } else if (size >= 1073741824) { // 1 GB
      val = (is_smart ? Math.round(size / 1073741824) : (size / 1073741824).toFixed(aftPoint)) + (is_smart ? 'GB' : ' GB');
    } else if (size >= 1048576) { // 1 MB
      val = (is_smart ? Math.round(size / 1048576) : (size / 1048576).toFixed(aftPoint)) + (is_smart ? 'MB' : ' MB');
    } else if (size >= 10240) {
      val = (size / 1048576).toFixed(aftPoint) + (is_smart ? "MB" : " MB");
    } else if (size >= 1) {
      val = (size / 1024).toFixed(aftPoint) + (is_smart ? "KB" : " KB");
    } else {
      val = "0" + (is_smart ? "B" : " B");
    }

    return pointed ? {first: val.split('.')[0], second: val.split('.')[1].split(' ')[0], text: val.split('.')[1].split(' ')[1]} : val;
  }
}

